import {
    FormSessionDto,
    FormSessionStateType
} from "../../../client/formsession/FormSessionApiClient";
import {useDefaultQuery} from "../../../client/useDefaultQuery";
import {useClientLocator} from "../../../client/ApiClientLocator";
import {useMemo} from "react";

export function useFormSessionStateQuery(formSessionId: number | undefined, readyToCheckState: boolean) {
    const {formSessionClient} = useClientLocator();

    const query = useDefaultQuery({
        queryKey: ['form-sessions', formSessionId, 'state'],
        queryFn: () => new Promise<FormSessionDto>((resolve, reject) => {
            formSessionClient.findById(formSessionId!)
                    .then((result) => {
                        if (result.state === FormSessionStateType.PREFILL_INFORMATION_OBTAINED) {
                            return resolve(result);
                        }

                        return reject(new Error("Form session is not in state " + FormSessionStateType.PREFILL_INFORMATION_OBTAINED + " but " + result.state + "."));
                    })
        }),
        enabled: !!formSessionId && readyToCheckState,
        retry: (failureCount) => failureCount < 20,
        retryDelay: () => 1000,
    });

    const state = useMemo(() => {
        let isObtained = query.isSuccess && !!query.data;
        let isFailed = query.isError;

        return {
            isFormSessionObtained: isObtained,
            isFormSessionFailed: isFailed
        };
    }, [query.isSuccess, query.isError, query.data]);

    return state;
}
